module.exports = __webpack_public_path__ + "static/lucas_santos-ac3c7c50ae7f7e18c266df9e44e72fb7.png";